import { DNABox, DNAButton, DNADivider, DNAText } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import React, { useEffect } from 'react'
import { StyleSheet } from 'react-native';
import { useDispatch } from 'src/state/redux';
import DNATrainingEventModal from 'src/components/DNA/Modal/DNATrainingEventModal';
import { TenantORM } from 'src/state/redux/selector/tenant';
import {
  useIstrainingEventHydrated,
  useTrainingEventsByTenantId,
} from 'src/state/redux/selector/trainingEvent';
import { DNAModalActions } from 'src/state/redux/slice/DNAModal/DNAModal';
import { TrainingEventFormProvider } from './TrainingEventProvider';
import { trainingEventActions } from 'src/state/redux/slice/trainingEvent';
import TrainingEventsList from './TrainingEventsList';

const styles = StyleSheet.create({
  mainWrapper: {
    backgroundColor: colors['color-text-white'],
    overflowX: 'auto',
  },
  listContainer: {
    padding: 24,
  },
  emptyStateText: {
    color: colors['color-gray-300'],
  },
  actionsContainer: {
    padding: 16,
  },
})

type EventsProps = {
  tenantORM: TenantORM // may need to change to tenantId instead of the entire ORM
}

const EmptyTrainingEvents: React.FC = () => {
  return (
    <DNABox alignX="center" alignY="center" fill>
      <DNAText style={styles.emptyStateText}>No events</DNAText>
    </DNABox>
  )
}

const Events = (props: EventsProps) => {
  const { tenantORM } = props
  const tenantTrainingEvents = useTrainingEventsByTenantId(props.tenantORM.tenant.id)
    .filter(events => !events.model.deleted)
  const isTrainingEventHydrated = useIstrainingEventHydrated()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(trainingEventActions.getTrainingEvents(tenantORM.tenant.id))
  }, [])

  const openCreateEventsModal = () => {
    dispatch(DNAModalActions.setModal({
      isVisible: true,
      allowBackdropCancel: true,
      component: (props) => (
        <TrainingEventFormProvider tenantId={tenantORM.tenant.id} toggleModal={props.toggleModal}>
          <DNATrainingEventModal {...props} tenantId={tenantORM.tenant.id}/>
        </TrainingEventFormProvider>
      ),
    }))
  }
  return (
    <DNABox style={styles.mainWrapper} fill appearance="col">
      <DNABox alignX="end" style={styles.actionsContainer}>
        <DNAButton
          size="sm"
          onPress={openCreateEventsModal}
        >
          Create event
        </DNAButton>
      </DNABox>
      <DNADivider />

      <DNABox appearance="col" fill>
        {!tenantTrainingEvents.length && !isTrainingEventHydrated
          ? <EmptyTrainingEvents /> : <TrainingEventsList trainingEvents={tenantTrainingEvents} tenantORM={tenantORM}/>}
      </DNABox>
    </DNABox>
  );
}

export default Events
